// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"874ba4a3","197":"1103fd39","220":"0183f9ab","723":"45a41447","789":"4f883cfd","835":"62629c07","865":"445df271"}[chunkId] + ".chunk.js";
};